var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3-2h40v40H-3z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7 10.041h8a7 7 0 0 1 7 7v1.4a5.6 5.6 0 0 1-5.6 5.6H4a4 4 0 0 1-4-4v-3a7 7 0 0 1 7-7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M7 10.541a6.5 6.5 0 0 0-6.5 6.5v3a3.5 3.5 0 0 0 3.5 3.5h12.4a5.1 5.1 0 0 0 5.1-5.1v-1.4a6.5 6.5 0 0 0-6.5-6.5H7z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.407,
    cy: 6,
    r: 6,
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#80959D"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.5 12.91h10a9.5 9.5 0 0 1 9.5 9.5v3.9a5.6 5.6 0 0 1-5.6 5.6H5.6a5.6 5.6 0 0 1-5.6-5.6v-3.9a9.5 9.5 0 0 1 9.5-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M9.5 13.41a9 9 0 0 0-9 9v3.9a5.1 5.1 0 0 0 5.1 5.1h17.8a5.1 5.1 0 0 0 5.1-5.1v-3.9a9 9 0 0 0-9-9h-10z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.452,
    cy: 7.5,
    r: 7.5,
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#80959D"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 26.7,
    cy: 26.7,
    r: 7.5,
    fill: "rgba(21, 87, 191, 0.7)",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.08 23.2h1.44v7.2h-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 26.08v1.44h-7.2v-1.44z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetCustomer);
export default __webpack_public_path__ + "static/media/target-customer.3f347036fc59f3c1e5d10ae5785a6c25.svg";
export { ForwardRef as ReactComponent };